/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Kiotviet_Link_Not_Kiotviet_OrderInputs */

const vi_error_kiotviet_link_not_kiotviet_order = /** @type {(inputs: Error_Kiotviet_Link_Not_Kiotviet_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ dòng của đơn KiotViet mới nối sản phẩm KiotViet được.`)
};

/**

* @param {Error_Kiotviet_Link_Not_Kiotviet_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_kiotviet_link_not_kiotviet_order = /** @type {((inputs?: Error_Kiotviet_Link_Not_Kiotviet_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Kiotviet_Link_Not_Kiotviet_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_kiotviet_link_not_kiotviet_order(inputs)
});